import { TextInput } from '@spoiler-alert/ui-library';
import accounting from 'accounting';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  row: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  inputContainer: {
    width: 161,
  },
});

const TRUCK_TYPES = ['dry', 'refrigerated', 'frozen'];
const LABELS = { dry: 'Dry', refrigerated: 'Refrigerated', frozen: 'Frozen' };

const formatValue = (value, format) => {
  const amount = value || 0;
  if (format === 'money') return accounting.formatMoney(amount);
  if (format === 'weight') return `${accounting.formatNumber(amount, 0)} lbs`;
  return accounting.formatNumber(amount, 0);
};

const InputContainer = ({ values, format = 'number', setTouched, onChange }) => {
  const classes = useStyles();
  const [errors, setErrors] = useState({
    dry: false,
    refrigerated: false,
    frozen: false,
  });
  const [revisions, setRevisions] = useState({
    dry: 0,
    refrigerated: 0,
    frozen: 0,
  });

  const validateInput = (value) => {
    const numericValue = accounting.unformat(value);
    if (/[a-zA-Z]/.test(numericValue) || /-/.test(numericValue)) {
      return false;
    }
    if (Number.isNaN(numericValue) || numericValue < 0) {
      return false;
    }
    return true;
  };

  const handleChange = (value, truckType) => {
    const isValid = validateInput(value);
    if (isValid) {
      setErrors((prevErrors) => ({ ...prevErrors, [truckType]: false }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, [truckType]: true }));
      setTouched(false);
      return;
    }
    setTouched(true);
  };

  const handleBlur = (value, truckType) => {
    setRevisions((prevRevisions) => ({ ...prevRevisions, [truckType]: prevRevisions[truckType] + 1 }));
    setErrors((prevErrors) => ({ ...prevErrors, [truckType]: false }));
    if (!validateInput(value)) return;
    onChange(truckType, accounting.unformat(value));
  };

  return (
    <div className={classes.row}>
      {TRUCK_TYPES.map((truckType) => (
        <div key={truckType} className={classes.inputContainer}>
          <TextInput
            key={revisions[truckType]}
            value={formatValue(values?.[truckType], format)}
            labelText={LABELS[truckType]}
            onChange={(v) => handleChange(v, truckType)}
            onBlur={(v) => handleBlur(v, truckType)}
            error={errors[truckType]}
          />
        </div>
      ))}
    </div>
  );
};

export default InputContainer;

InputContainer.propTypes = {
  values: PropTypes.shape({
    dry: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    refrigerated: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    frozen: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  format: PropTypes.oneOf(['money', 'weight', 'number']),
  onChange: PropTypes.func,
  setTouched: PropTypes.func,
};
